import { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { Provider } from 'react-redux';
import { Outlet, RouterProvider, createBrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import LayoutWrapper from './Components/LayoutWrapper';
import Collection from './Pages/Collection';
import Home from './Pages/Home';
import Search from './Pages/Search';
import UserCollection from './Pages/UserCollection';
import { getCsrfToken } from './redux/appSlice';
import getStore from './redux/store';

const router = createBrowserRouter(
  [
    {
      element: (
        <LayoutWrapper>
          <Outlet />
        </LayoutWrapper>
      ),
      children: [
        {
          path: '/',
          element: <Home />,
        },
        {
          path: '/collection',
          element: <Collection />,
        },
        {
          path: '/search',
          element: <Search />,
        },
        {
          path: '/user/collections',
          element: <UserCollection />,
        },
      ],
    },
  ],
  {
    basename: '/image-library',
  }
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // default: true
    },
  },
});
const { store, persistor } = getStore();

function App() {
  useEffect(() => {
    document.querySelector('.breadcrumbs-bar')?.remove();
    store.dispatch(getCsrfToken());
  }, []);

  console.log('App rendered! HEY!!!');

  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <RouterProvider router={router} />
          <ReactQueryDevtools initialIsOpen={false} />
        </PersistGate>
      </Provider>
    </QueryClientProvider>
  );
}

export default App;
